<template>
  <div class="list-comment col-12 mt-4">
    <div class="row">
      <div v-for="comment in comments" v-bind:key="comment.id" class="comment-item">
        <div class="comment-wrap">
          <div class="comment-avatar">
            <img src="@/assets/images/owner.png" class="img-fit" />
          </div>
          <div class="comment-contain">
            <div class="comment-top">
              <div class="user-name">{{comment.user.name}}</div>
              <div class="date-time" v-show="comment.dateTime">{{comment.dateTime | moment('from')}}</div>
              <div class="btn-link-preview action-button mx-1" @click="openReply(comment)">
                <i class="fa fa-reply"></i>
              </div>
              <div
                class="btn-link-edit action-button mx-1"
                v-show="isOwnerComment( comment.user.name)"
                @click="editComment(comment)"
              >
                <i class="fa fa-pencil"></i>
              </div>
              <div
                class="btn-link-delete action-button mx-1"
                v-show="isOwnerComment( comment.user.name)"
                @click="removeComment(comment.id)"
              >
                <i class="fa fa-trash"></i>
              </div>
            </div>
            <div class="comment-body" v-html="comment.content"></div>
          </div>
        </div>
        <div class="comment-child">
          <div v-for="child in comment.replies" v-bind:key="child.id" class="comment-item">
            <div class="comment-wrap">
              <div class="comment-avatar">
                <img src="@/assets/images/owner.png" class="img-fit" />
              </div>
              <div class="comment-contain">
                <div class="comment-top">
                  <div class="user-name">{{child.user.name}}</div>
                  <div class="date-time" v-show="child.dateTime">{{child.dateTime | moment('from')}}</div>
                  <div
                    class="btn-link-edit action-button mx-1"
                    v-show="isOwnerComment(child.user.name)"
                    @click="editComment(child)"
                  >
                    <i class="fa fa-pencil"></i>
                  </div>
                  <div
                    class="btn-link-delete action-button mx-1"
                    v-show="isOwnerComment(child.user.name)"
                    @click="removeComment(child.id)"
                  >
                    <i class="fa fa-trash"></i>
                  </div>
                </div>
                <div class="comment-body" v-html="child.content"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <b-button @click="onComment" variant="comment">
        <i class="fa fa-comments mr-2"></i>Bình luận
      </b-button>
      <b-modal v-model="show" title="Bình luận" size="lg" hide-footer>
        <p class="mb-4">
          <ckeditor :editor="editor" v-model="commentValue" :config="editorConfig"></ckeditor>
        </p>
        <div class="button-control">
          <b-button variant="comment" class="float-left" @click="submit" :disabled="!commentValue">
            <i class="fa fa-comments mr-2"></i>Bình luận
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { BModal, VBModal, BButton } from "bootstrap-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  createComment,
  getComments,
  updateComment,
  deleteComment
} from "../../common/comment";
import Vue from "vue";

export default {
  name: "CommentList",
  components: { BModal, BButton },
  directives: {
    "b-modal": VBModal
  },
  data() {
    return {
      comments: [],
      show: false,
      isEdit: false,
      commentValue: "",
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        removePlugins: ["MathType", "ChemType"]
      },
      replyCommentId: null,
      editableComment: null
    };
  },
  methods: {
    isOwnerComment(userName) {
      if (!userName) {
        return false;
      }

      const currentUser = Vue.$cookies.get("username") || "";
      if (!currentUser) {
        return false;
      }

      return currentUser.toLowerCase() === userName.toLowerCase();
    },
    getIpId() {
      return this.$route.params.id;
    },
    async getComments() {
      const comments = [];
      const data = await getComments(this.$route.params.id);
      const dict = {};

      for (var comment of data) {
        const item = {
          id: comment.id,
          user: {
            avatar: "@/assets/images/owner.png",
            name: comment.createdBy
          },
          content: comment.contentComment,
          dateTime:
            (comment.createdTime && new Date(comment.createdTime)) || "",
          parentId: comment.parentId,
          replies: []
        };
        dict[comment.id] = item;
      }

      for (const [key, item] of Object.entries(dict)) {
        if (item.parentId > 0) {
          const parentComment = dict[item.parentId];
          if (!parentComment) {
            continue;
          }
          if (parentComment.replies) {
            parentComment.replies.push(item);
          } else {
            parentComment.replies = [item];
          }
        }
      }
      for (const [key, item] of Object.entries(dict)) {
        if (item.parentId == 0) {
          comments.push(item);
        }
      }
      this.comments = [...comments];
      if (comments.length && comments.length > 0) {
        $("#comment_count").remove();
        $("#t-commentTab .tabs__link").prepend(
          `<span id=\"comment_count\" style='position: relative; float: right; right: 15px; top: 5px; font-size: 10px; font-weight: bold; color: #3299ba;'>${comments.length}</span>`
        );
      } else {
        $("#comment_count").remove();
      }
    },
    async submit() {
      if (!this.isEdit) {
        await this.createComment();
      } else {
        await this.updateComment();
      }

      this.show = false;
      this.commentValue = "";
      await this.getComments();
    },
    async createComment() {
      const comment = {
        contentComment: this.commentValue,
        contentId: this.getIpId(),
        parentId: this.replyCommentId,
        isFeedBack: 0
      };

      await createComment(comment);
    },
    onComment() {
      this.show = true;
      this.replyCommentId = null;
    },
    openReply(comment) {
      this.commentValue = "";
      this.show = true;
      this.replyCommentId = comment.id;
    },
    editComment(comment) {
      this.commentValue = comment.content;
      this.show = true;
      this.editableComment = comment;
      this.isEdit = true;
    },
    async updateComment() {
      this.isEdit = false;
      const editableComment = this.editableComment;
      editableComment.content = this.commentValue;
      const updatedForm = {
        id: editableComment.id,
        contentComment: this.commentValue,
        parentId: editableComment.parentId,
        contentId: this.getIpId(),
        isFeedBack: 0
      };

      await updateComment(updatedForm);
    },
    async removeComment(id) {
      this.$confirm({
        message: `Bạn có muốn xóa comment này ?`,
        button: {
          no: "Hủy",
          yes: "Đồng ý"
        },
        callback: async confirm => {
          if (confirm) {
            await deleteComment(id);
            await this.getComments();
          }
        }
      });
    }
  },
  async mounted() {
    await this.getComments();
  }
};
</script>
<style scoped>
.comment-item {
  border-bottom: 1px #eaeaea solid;
  padding: 10px 0;
  width: 100%;
}
.comment-item .comment-item {
  border-bottom: none;
}
.comment-wrap {
  display: flex;
}
.comment-avatar {
  height: 32px !important;
  width: 32px !important;
}
.comment-contain {
  width: 100%;
  margin-left: 10px;
}
.comment-contain .comment-top {
  display: flex;
  align-items: flex-end;
}

.comment-contain .comment-top .user-name {
  color: #3199bb;
  font-weight: 600;
}

.comment-contain .comment-top .date-time {
  font-size: 12px;
  margin-left: 10px;
}

.comment-contain .comment-body {
  font-size: 13px;
  margin-top: 7px;
}
.comment-child {
  padding-left: 40px;
}
.btn-comment {
  background: #3199bb;
  border: 1px solid #3199bb;
  color: #fff;
}
.btn-comment:hover {
  background: #fff;
  border: 1px solid #3199bb;
  color: #3199bb;
}
.comment-top .action-button {
  opacity: 0.3;
}
.comment-top .action-button:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CommentList.vue